module.exports = __webpack_public_path__ + "img/MGH-Gaien-11-2440x1172.bea1ab05.jpg";